// extracted by mini-css-extract-plugin
export default {"apiErrorMessage":"sflOU","notificationDrawer":"NaMgp","show":"JPbix"};